import { FC } from "react";

import {
  BooleanImageIconTemplate,
  DateCountdownReadonlyTemplate,
  IdLabelTemplate,
  NotificationContentTemplate,
} from "@ryde/controls";
import { FORM_FIELD_KEYS } from "@ryde/shared";

export const readonlyFieldNameToField: Partial<
  Record<FORM_FIELD_KEYS, FC<any>>
> = {
  boolean_image_icon: BooleanImageIconTemplate,
  id_label: IdLabelTemplate,
  notification_content: NotificationContentTemplate,
  date_countdown_readonly: DateCountdownReadonlyTemplate,
};
